var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStreamlineIconMeetingCamera = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  width: 15,
  height: 13,
  x: 0.25,
  y: 5.5,
  rx: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.51 6.07a.48.48 0 0 0-.48 0l-6 3a.51.51 0 0 0-.28.45v5A.51.51 0 0 0 17 15l6 3a.51.51 0 0 0 .72-.45V6.5a.52.52 0 0 0-.21-.43"
}))));
export default SvgStreamlineIconMeetingCamera;